class ProductDescriptionTabsTest extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[data-product-description-tab]'));
    this.panels = Array.from(this.querySelectorAll('[data-product-description-panel]'));
    this.accordions = Array.from(this.querySelectorAll('[data-product-description-accordion]'));

    if (!this.tabs.length || !this.panels.length) return;

    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.select(index));
      tab.addEventListener('keydown', (event) => this.onTabKeydown(event, index));
    });

    this.accordions.forEach((accordion, index) => {
      accordion.addEventListener('click', () => this.select(index));
    });

    this.select(0);
    this.classList.add('is-ready');
  }

  select(activeIndex) {
    this.tabs.forEach((tab, index) => {
      const isActive = index === activeIndex;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    this.panels.forEach((panel, index) => {
      const isActive = index === activeIndex;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    });

    this.accordions.forEach((accordion, index) => {
      accordion.setAttribute('aria-expanded', index === activeIndex ? 'true' : 'false');
    });
  }

  onTabKeydown(event, index) {
    let nextIndex = index;

    if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
      nextIndex = index + 1 >= this.tabs.length ? 0 : index + 1;
    } else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
      nextIndex = index - 1 < 0 ? this.tabs.length - 1 : index - 1;
    } else if (event.key === 'Home') {
      nextIndex = 0;
    } else if (event.key === 'End') {
      nextIndex = this.tabs.length - 1;
    } else {
      return;
    }

    event.preventDefault();
    this.select(nextIndex);
    this.tabs[nextIndex].focus();
  }
}

if (!customElements.get('product-description-tabs-test')) {
  customElements.define('product-description-tabs-test', ProductDescriptionTabsTest);
}
